import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Menu, Search, User } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUser, logout } from "../../../Redux/Auth/Action";
import { clearCart, getCart } from "../../../Redux/Customers/Cart/Action";
import logo from "./HeaderImg/econirmit_logo.png";
import popesoimg from "./HeaderImg/CARBON NEUTRAL.png";
import ecocart from "./HeaderImg/eco cart.png";
import SidebarCart from "../../../Pages/SidebarCart";
import { toast, ToastContainer } from "react-toastify";
import AuthModal from "../Auth/AuthModal";
import { Menu as MuiMenu, MenuItem } from "@mui/material";

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth, cart } = useSelector((store) => store);
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [showWelcomePopup, setShowWelcomePopup] = useState(true);
  const [isCartOpen, setCartOpen] = useState(false);
  const jwt = localStorage.getItem("jwt");
  const [anchorEl, setAnchorEl] = useState(null);
  const openUserMenu = Boolean(anchorEl);

  const toggleCart = () => {
    setCartOpen(!isCartOpen);
  };

  const handleCloseUserMenu = () => {
    setAnchorEl(null);
  };

  const handleUserMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMyOrdersClick = () => {
    handleCloseUserMenu();
    navigate("/account/order");
  };

  const handleProfileClick = () => {
    handleCloseUserMenu();
    navigate("/account/profile");
  };

  const handleLogoutClick = () => {
    handleCloseUserMenu();
    dispatch(logout());
    dispatch(clearCart()); // ✅ clear Redux store
    navigate("/");
    toast.success("Logged out successfully");
  };

  // const handleCloseUserMenu = () => {
  //   setAnchorEl(null);
  // };

  const handleMyOrderClick = () => {
    handleCloseUserMenu();
    navigate("/account/order");
  };

  const handleLogout = () => {
    handleCloseUserMenu();
    dispatch(logout());
  };



  useEffect(() => {
    if (jwt) {
      dispatch(getUser(jwt));
      dispatch(getCart(jwt));
    }
  }, [jwt, auth.jwt]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowBanner(false);
      } else {
        setShowBanner(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleOpen = () => setOpenAuthModal(true);
  const handleClose = () => setOpenAuthModal(false);
  const handleUserClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Shop", path: "/product/econirmit/all" },
    { name: "Contact us", path: "/ContactPage" },
  ];

  return (
    <>
      {showBanner && (
        <div className="marquee-container bg-black py-5 overflow-hidden fixed w-full top-0 z-50">
          <div className="marquee-content animate-marquee text-white font-500">
            {/* Duplicate content for seamless loop */}
            <div className="marquee-track">
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>  {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
            </div>
            <div className="marquee-track">
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
              {/* <span className="mx-4">Flat 20% off</span> */}
              <span className="mx-4">Free Shipping on Orders above INR 750</span>
            </div>
          </div>

          <style jsx>{`
      .marquee-container {
        position: relative;
        overflow: hidden;
        z-index: 50;
      }
      .marquee-content {
        display: flex;
        width: fit-content;
        animation: marquee 40s linear infinite;
      }
      .marquee-track {
        display: flex;
        white-space: nowrap;
      }
      @keyframes marquee {
        0% {
          transform: translateX(0%);
        }
        100% {
          transform: translateX(-50%);
        }
      }
    `}</style>
        </div>
      )}


      {/* Header */}
      <header
        className={`fixed left-0 right-0 z-40 bg-white border-b shadow transition-all ${showBanner ? "top-[50px]" : "top-0"
          }`}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="flex items-center justify-between"
            style={{ paddingTop: "30px", paddingBottom: "20px" }}
          >
            <div className="flex lg:hidden">
              <button
                className="rounded-md bg-white p-2 text-gray-400"
                onClick={() => setMobileMenuOpen(true)}
              >
                <Bars3Icon className="h-6 w-6" />
              </button>
            </div>

            <Link to="/" className="flex justify-center w-full lg:w-auto">
              <img src={logo} alt="logo" className="logonavbar" />
            </Link>

            <nav className="hidden lg:flex lg:space-x-8">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="px-3 py-2 text-gray-700 hover:text-gray-900 font-bold"
                >
                  {item.name}
                </Link>
              ))}
            </nav>

            <div className="flex items-center space-x-4">
              {auth.user ? (
                <>
                  <button
                    onClick={handleUserMenuClick}
                    className="flex items-center gap-1"
                  >
                    <User strokeWidth={1.5} />
                  </button>

                  <MuiMenu
                    anchorEl={anchorEl}
                    open={openUserMenu}
                    onClose={handleCloseUserMenu}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <Link to='/account/order'>   <MenuItem >My Orders</MenuItem> </Link>
                    <Link to='/user-profile'>  <MenuItem>Profile</MenuItem> </Link>
                    <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
                  </MuiMenu>
                </>
              ) : (
                <button
                  onClick={handleOpen}
                  className="text-gray-700 hover:text-gray-900"
                >
                  Sign in
                </button>
              )}
              <button onClick={toggleCart} className="relative">
                <img src={ecocart} className="cart-img" />
                {cart.cart?.totalItem > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                    {cart.cart.totalItem}
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
        <SidebarCart isOpen={isCartOpen} onClose={toggleCart} showBanner={showBanner} />
      </header>

      {/* Padding to prevent overlap */}
      <div className={`${showBanner ? "pt-[100px]" : "pt-[60px]"}`}></div>

      <ToastContainer />
      <Transition show={mobileMenuOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50 lg:hidden" onClose={setMobileMenuOpen}>
          <Transition.Child
            as={Fragment}
            enter="transition ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 z-50 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-out duration-300"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in duration-200"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative mr-auto w-full max-w-xs bg-white shadow-xl p-6">
                <div className="flex items-center justify-between mb-6">
                  <img src={logo} alt="logo" className="h-10" />
                  <button onClick={() => setMobileMenuOpen(false)} className="text-gray-500 hover:text-black">
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>
                <nav className="space-y-4">
                  {navItems.map((item) => (
                    <Link
                      key={item.name}
                      to={item.path}
                      className="block text-gray-800 font-semibold hover:text-black"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {item.name}
                    </Link>
                  ))}
                </nav>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>

      {/* Popes Image Modal */}
      {/* <Transition appear show={showWelcomePopup} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => setShowWelcomePopup(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white  text-left align-middle shadow-xl transition-all">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      padding: "15px",
                    }}
                  >
                    <img
                      src={popesoimg}
                      alt="Popes Image"
                      className="w-full h-auto"
                      style={{ borderRadius: "12px" }}
                    />
                    <button
                      // Inside onClick:
                      onClick={() => {
                        navigator.clipboard.writeText("SAVEECO20");
                        toast.success("Code copied!");
                        setShowWelcomePopup(false);
                      }}
                      style={{
                        padding: "12px 50px",
                        backgroundColor: "#F7D720",
                        outline: "none",
                        border: "none",
                      }}
                      className="mt-4 mb-4 rounded px-4 py-2 text-white font-medium hover:bg-gray-800"
                    >
                      Copy And Continue Shopping
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition> */}
      <AuthModal handleClose={handleClose} open={openAuthModal} />
    </>
  );
}
